const getInvestorDetails = (uuid, investors) => investors.find(({ uuid: investorUuid }) => investorUuid === uuid);

export { getInvestorDetails };
